import {
    SET_SUPPLIERS,
} from "@/views/suppliers/store/types/types.js";

const mutations = {
    [SET_SUPPLIERS]: (state, payload) => state.suppliers = payload,
};

export default mutations